import React, { useState, useEffect } from "react";
import {
  AddSlabIcon,
  DeleteIcon,
} from "../../../utility/constants/assetsManager";
import {
  colorLightGrey,
  colorWhite,
  secondaryColor,
} from "../../../utility/constants/colorManager";
import {
  PERCENTAGE,
  RUPEES,
  RUPEES_SYMBOL,
} from "../../../utility/constants/valueConstants";

import { CustomInput } from "../main_comps/custom_input/CustomInput";
import "./index.css";
import "../../../scrollStyles.css";
import { useSnackbar } from "notistack";
import { Input, Select } from "antd";
import { Controller, FormProvider, useForm } from "react-hook-form";
import { CustomButton } from "../main_comps/custom_button";

export const Divider = ({ style }) => {
  return (
    <div
      style={{
        backgroundColor: "#D9D9D9",
        height: 80,
        width: 1,
        ...style,
      }}
    ></div>
  );
};
const RadioButton = ({
  id,
  value,
  name,
  title,
  onChange,
  defaultChecked,
  style,
  disabled = false,
}) => {
  return (
    <div
      style={{
        ...style,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <input
        disabled={disabled}
        type="radio"
        id={id}
        name={name}
        value={value}
        onChange={onChange}
        defaultChecked={defaultChecked}
        checked={defaultChecked}
        style={{
          margin: "0px 10px",
        }}
      />
      <label htmlFor={id}>{title}</label>
    </div>
  );
};

const FlatContainer = ({
  onChange,

  rate,
  disabled = false,
  isEditClicked,
  clientRateEmpty,
  isValuesAdded,

  empty,
}) => {
  const [amount, setAmount] = useState("");
  const [value, setValue] = useState(RUPEES);
  useEffect(() => {
    if (empty === undefined || empty === "slab") {
      setAmount("");
      setValue(RUPEES);
    }
  }, [empty]);

  useEffect(() => {
    if (isValuesAdded) {
      setAmount("");
    }
  }, [isValuesAdded]);

  const onChangeValues = (amount, value) => {
    onChange(amount, value);
  };

  useEffect(() => {
    if (rate?.length > 0) {
      setAmount(rate[0]?.value);
      setValue(rate[0]?.type);
    }
  }, [rate]);

  useEffect(() => {
    if (!isEditClicked && rate?.length > 0) {
      setAmount(rate[0]?.value);
      setValue(rate[0]?.type);
    }
  }, [!isEditClicked, rate]);

  useEffect(() => {
    if (clientRateEmpty) {
      setAmount("");
    }
  }, [clientRateEmpty]);

  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: 20,
      }}
    >
      <CustomInput
        disabled={disabled}
        type="select"
        options={[
          {
            label: `${RUPEES_SYMBOL}`,
            value: RUPEES,
          },
          {
            label: `%`,
            value: PERCENTAGE,
          },
        ]}
        value={value}
        inputStyles={{
          width: 70,
          minWidth: 0,
          border: "1px solid #CBCBCB",
        }}
        containerStyles={{
          width: 70,
          border: "1px solid #CBCBCB",
        }}
        onChange={(val) => {
          setValue(val);
          onChangeValues(amount, val);
        }}
      />
      <CustomInput
        disabled={disabled}
        value={amount}
        onChange={(data) => {
          setAmount(data);
          onChangeValues(data, value);
        }}
        inputcomponentStyles={{ ...styles.inputStyle }}
        placeholder=""
        validator={value === RUPEES ? "paise" : "percentageDecimal"}
        type="input"
        inputStyles={{
          ...styles.containerStyle,
        }}
      />
    </div>
  );
};

// const SlabContainer = ({
//   onChangeTexts,
//   isValuesAdded,
//   disabled = false,

//   empty,
// }) => {
//   const [from, setFrom] = useState("");
//   const [to, setTo] = useState("");
//   const [amount, setAmount] = useState("");
//   const [value, setValue] = useState(RUPEES);

//   useEffect(() => {
//     if (empty === undefined) {
//       setFrom("");
//       setTo("");
//       setAmount("");
//       setValue(RUPEES);
//     }
//   }, [empty]);

//   useEffect(() => {
//     if (isValuesAdded) {
//       setFrom("");
//       setTo("");
//       setAmount("");
//       setValue("");
//     }
//   }, [isValuesAdded]);

//   const onChangeValues = (amount, value, from, to) => {
//     onChangeTexts(amount, value, from, to);
//   };

//   return (
//     <div
//       style={{
//         display: "flex",
//         alignItems: "center",
//         border: "1px solid #CBCBCB",
//         borderRadius: 5,
//         padding: "10px",
//         boxSizing: "border-box",
//         width: "100%",
//         justifyContent: "space-between",
//       }}
//     >
//       <div
//         style={{
//           display: "flex",
//           flexDirection: "column",
//           flex: 0.55,
//           rowGap: 20,
//         }}
//       >
//         <div>
//           <p>From</p>
//           <CustomInput
//             disabled={disabled}
//             value={from}
//             onChange={(data) => {
//               setFrom(data);
//               onChangeValues(amount, value, data, to);
//             }}
//             inputcomponentStyles={{ ...styles.inputStyle }}
//             placeholder=""
//             validator="number"
//             type="input"
//             inputStyles={{
//               ...styles.containerStyle,
//             }}
//           />
//         </div>
//         <div>
//           <p>To</p>
//           <CustomInput
//             disabled={disabled}
//             value={to}
//             onChange={(data) => {
//               setTo(data);
//               onChangeValues(amount, value, from, data);
//             }}
//             inputcomponentStyles={{ ...styles.inputStyle }}
//             placeholder=""
//             validator="number"
//             type="input"
//             inputStyles={{
//               ...styles.containerStyle,
//             }}
//           />
//         </div>
//       </div>
//       <Divider
//         style={{
//           display: "flex",
//           margin: "0px 10px",
//         }}
//       />
//       <div
//         style={{
//           display: "flex",
//           flex: 0.4,
//           padding: "0px 10px",
//         }}
//       >
//         <FlatContainer
//           disabled={disabled}
//           onChange={(amount, val) => {
//             setAmount(amount);
//             onChangeValues(amount, val, from, to);
//             setValue(val);
//           }}
//           isValuesAdded={isValuesAdded}
//         />
//       </div>
//     </div>
//   );
// };

export const checkObjHasAllValue = (obj) => {
  if (Object.keys(obj)?.length === 0) {
    return false;
  } else {
    let val = Object.keys(obj).every((val) => {
      return obj[val] !== "" && obj[val] !== undefined;
    });
    return val;
  }
};

export const checkAnyOneObjHasAllValue = (obj) => {
  if (Object.keys(obj)?.length === 0) {
    return false;
  } else {
    let val = Object.keys(obj).some((val) => {
      return obj[val] !== "";
    });
    return val;
  }
};

// KEEPS TRACK OF THE ADDED VALUES
// EMPTY FIELD VALIDATION WORKING
// REGEX ADDED FOR THE SELECT FIELD
const CommissionSlabContainer = ({ handleDataUpdate, type }) => {
  const methods = useForm();
  const { handleSubmit, control, watch, setValue } = methods;

  const slabs = watch("slabs", []);

  useEffect(() => {
    const defaultSlabs = [
      {
        type: type,
        from: "",
        to: "",
        currency: "",
        amount: "",
      },
    ];
    setValue("slabs", defaultSlabs);
  }, [setValue]);

  useEffect(() => {
    slabs.forEach((slab, index) => {
      setValue(`slabs[${index}].from`, slab.from);
      setValue(`slabs[${index}].to`, slab.to);
      setValue(`slabs[${index}].amount`, slab.amount);
      setValue(`slabs[${index}].currency`, slab.currency);
    });
  }, [slabs, setValue]);

  const onSubmit = (data) => {
    console.log(data, "111111112222");
    handleDataUpdate(data.slabs);

  };

  const addSlab = () => {
    const hasEmptyFields = slabs.some(
      (slab) => !slab.from || !slab.to || !slab.currency || !slab.amount
    );
    if (slabs.length < 5 && !hasEmptyFields) {
      const newSlab = {
        from: "",
        to: "",
        currency: "",
        amount: "",
      };
      setValue("slabs", [...slabs, newSlab]);
    }
  };

  const removeSlab = (index) => {
    const updatedSlabs = slabs.filter((_, i) => i !== index);
    setValue("slabs", updatedSlabs);
  };

  return (
    <FormProvider {...methods}>
      <form onSubmit={handleSubmit(onSubmit)}>
        {slabs.map((slab, index) => (
          <div key={index} className="flex flex-col justify-start items-start w-full my-2 space-x-4">
            <div className="w-full flex flex-row space-y-1">
              <div className="w-full flex-col space-y-1">
                <label className="text-sm block">From</label>
                <div className="w-[50%]">
                  <Controller
                    control={control}
                    name={`slabs[${index}].from`}
                    defaultValue={slab.from}
                    render={({ field }) => (
                      <Input size="large" {...field} required />
                    )}
                  />
                </div>
              </div>
              <div className="w-full flex-col space-y-1">
                <label className="text-sm block">To</label>
                <div className="w-[50%]">
                  <Controller
                    control={control}
                    name={`slabs[${index}].to`}
                    defaultValue={slab.to}
                    render={({ field }) => (
                      <Input size="large" {...field} required />
                    )}
                  />
                </div>
              </div>
              <div className="w-[50%] space-y-1 pt-5 mx-2 border-l-2 pl-4">
                <div>
                  <Controller
                    control={control}
                    name={`slabs[${index}].currency`}
                    defaultValue={slab.currency}
                    render={({ field }) => (
                      <Select
                        size="large"
                        style={{ width: "100%" }}
                        {...field}
                        options={[
                          { label: 'RUPEES', value: 'RUPEES' },
                          { label: '%', value: 'PERCENTAGE' },
                        ]}
                        required
                        isSearchable={false}
                      />
                    )}
                  />
                </div>
              </div>
              <div className="w-[75%] space-y-1 pt-5">
                <div>
                  <Controller
                    control={control}
                    name={`slabs[${index}].amount`}
                    defaultValue={slab.amount}
                    render={({ field }) => (
                      <Input size="large" {...field} required />
                    )}
                  />
                </div>
              </div>
              <div className="pt-7 mx-2">
                <DeleteIcon onClick={() => removeSlab(index)} />
              </div>
            </div>
          </div>
        ))}
        {slabs.length < 5 && (
          <div className="w-full justify-start items-start flex" onClick={addSlab}>
            <AddSlabIcon style={{ marginRight: 15 }} />
            <p style={{ color: 'secondaryColor', fontSize: 13 }}>Add More Slab</p>
          </div>
        )}
        <div className="w-full justify-end items-end flex">
          <CustomButton title={"Save"} style={{ fontSize: 13 }} type="submit" />
        </div>
      </form>
    </FormProvider>
  );
};

function CommissionOnPayment({
  onClickNext,
  isSlabRequired = true,
  styles,
  innerStyles,
  rate,
  type,
  ex,
  disabled = false,
  isEditClicked,
  clientRateEmpty,
  title,
  handleDataUpdate

}) {
  const [currentValue, setCurrentValue] = useState("flat");
  const [totalCommission, setTotalCommission] = useState([]);
  const [flatComission, setFlatComission] = useState({});
  const [comissionObj, setComissionObj] = useState({});
  const [currentObject, setCurrentObject] = useState({});
  const [empty, setEmpty] = useState("flat");


  useEffect(() => {
    if (totalCommission.length > 0)
      onClickNext([...totalCommission], {}, currentValue);
  }, [totalCommission]);

  useEffect(() => {
    if (checkObjHasAllValue(currentObject))
      onClickNext([...totalCommission, comissionObj], {}, currentValue);
  }, [currentObject, currentValue]);

  useEffect(() => {
    onClickNext([], flatComission, currentValue);
  }, [flatComission, currentValue]);


  useEffect(() => {
    if (currentValue === "flat") {
      setTotalCommission([]);
    } else {
      setFlatComission({});
      setEmpty("slab");
    }
  }, [currentValue]);

  useEffect(() => {
    if (type && type?.toLowerCase() === "flat") {
      setCurrentValue("flat");
      setFlatComission(rate[0]);
    } else if (type && type?.toLowerCase() === "slab") {
      setCurrentValue("slab");
      setTotalCommission(rate);
    }
  }, [type, rate]);

  useEffect(() => {
    console.log(currentValue, "current value")
  }, [currentValue])

  const handleSlabDataUpdate = (data) => {
    // setTotalCommission(data);
    onClickNext(data);  // You might need to pass the correct parameters here
  };

  return (
    <div
      style={{
        width: "100%",
        backgroundColor: colorLightGrey,
        boxSizing: "border-box",
        padding: 10,
        ...styles,
      }}
    >
      <div className="font-inter border-b-2 px-2 text-lg font-bold">
        {title}
      </div>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          padding: "15px 0px",
          ...innerStyles,
        }}
      >
        <div
          style={{
            flex: 0.55,
            display: "flex",
          }}
        >
          <RadioButton
            disabled={disabled}
            id="flat"
            name={"flat_radio" + ex}
            title="Flat"
            value="flat"
            onChange={(val) => {
              setCurrentValue(val.target.value);
            }}
            defaultChecked={currentValue === "flat"}
          />

          {isSlabRequired && (
            <RadioButton
              disabled={disabled}
              id="slab"
              name={"flat_radio" + ex}
              title="Slab"
              value="slab"
              onChange={(val) => {
                setCurrentValue(val.target.value);
              }}
              defaultChecked={currentValue === "slab"}
              style={{
                margin: "0px 10px",
              }}
            />
          )}
        </div>
        {currentValue === "flat" && (
          <Divider
            style={{
              display: "flex",
              height: 40,
              margin: "0px 10px",
            }}
          />
        )}
        {currentValue === "flat" && (
          <div
            style={{
              display: "flex",
            }}
          >
            <FlatContainer
              disabled={disabled}
              onChange={(amount, val) => {
                setFlatComission({
                  value: amount,
                  type: val,
                });
              }}
              rate={rate}
              isEditClicked={isEditClicked}
              clientRateEmpty={clientRateEmpty}
              currentValue={currentValue}
              empty={empty}
            />
          </div>
        )}
      </div>
      {currentValue === "slab" && (
        <div
          style={{
            width: "100%",
            backgroundColor: colorWhite,
            maxHeight: 300,
            overflow: "auto",
          }}
        >
          <CommissionSlabContainer handleDataUpdate={handleSlabDataUpdate} type={currentValue} />
        </div>
      )}

      {/* {currentValue === "slab" && (
        <div
          style={{
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            margin: "10px 0px",
            width: "auto",
          }}
          onClick={() => {
            if (checkObjHasAllValue(comissionObj)) {
              setTotalCommission([...totalCommission, comissionObj]);
              setComissionObj({});
              //  onObjAdded();
              setCurrentObject({});
              setIsValuesAdded(true);
            } else {
              enqueueSnackbar("Please enter all the fields", {
                variant: "error",
              });
            }
          }}
        >
          <AddSlabIcon
            style={{
              marginRight: 15,
            }}
          />
          <p
            style={{
              color: secondaryColor,
              fontSize: 13,
            }}
          >
            Add More Slab
          </p>
        </div>
      )} */}
    </div>
  );
}

const styles = {
  inputStyle: {
    alignSelf: "center",
    boxShadow: "none",
    outline: "none",
    paddingLeft: 10,
    borderRadius: 5,
    boxSizing: "border-box",
    width: "100%",
  },
  containerStyle: {
    padding: 0,
    height: 50,
    width: 60,
    height: 40,
    margin: 0,
    backgroundColor: colorWhite,
    border: "1px solid #CBCBCB",
  },
};
export default CommissionOnPayment;
